"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    PromoButton: ()=>PromoButton
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_CdnIcon_index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_PromoButton_variants_cjs_namespaceObject = require("./PromoButton.variants.cjs");
function PromoButton({ promoText, icon, customNode, actionText, className, as = 'button', ...props }) {
    const { rootSlot, iconWrapperSlot, textContentSlot, textIconGroupSlot, actionTextSlot } = (0, external_PromoButton_variants_cjs_namespaceObject.promoButtonVariants)({
        palette: props.palette,
        emphasis: props.emphasis
    });
    const renderIcon = ()=>{
        if (customNode) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
            className: iconWrapperSlot(),
            children: customNode
        });
        if (icon) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
            iconName: icon,
            className: iconWrapperSlot()
        });
        return null;
    };
    const content = /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                className: textIconGroupSlot(),
                children: [
                    renderIcon(),
                    promoText && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: textContentSlot(),
                        children: promoText
                    })
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                className: actionTextSlot(),
                "aria-hidden": "true",
                children: actionText
            })
        ]
    });
    const ElementTag = as;
    const cleanedProps = (0, index_cjs_namespaceObject.cleanProps)(props, [
        'palette',
        'emphasis',
        'as'
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ElementTag, {
        className: (0, index_cjs_namespaceObject.cn)(rootSlot(), className),
        ...cleanedProps,
        children: content
    });
}
exports.PromoButton = __webpack_exports__.PromoButton;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "PromoButton"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
